import React from "react";
import styles from "./admincommoncomponent.module.css";
import { BsInfoCircle } from "react-icons/bs";
import Select from "react-select";
import { IoMdArrowDropdown } from "react-icons/io";
import GradientButton from "../../../Components/Button/GradientButton";

const AdminCommonComponent = ({ buttonName, handleButton, header, data }) => {

  const handleChange = (e) => { }

  const formatPhoneNumber = (label, value) => {
    if (label === "Phone" && value) {
      if (value.startsWith("233") && value.length > 3) {
        return `+233 ${value.substring(3)}`;
      }
      return value;
    }
    return value;
  };



  return (
    <>
      <div className={styles.container}>
        <div className="flex justify-between">
          <p style={{ fontSize: "1.5rem" }}>{header}</p>
          {buttonName && <GradientButton label={buttonName} onClick={handleButton} />}
        </div>
        {data &&
          data.map((item) => (
            <div className={styles.items_container}>
              <span style={{ fontSize: "0.9rem" }} className="flex items-center">
                {item.label}&nbsp;&nbsp;
                <span data-title={item.title} id={styles.span} >
                  {item.title && (
                    <BsInfoCircle
                      size={"0.9rem"}
                      cursor={"pointer"}
                      style={{ paddingTop: "1px" }}
                    />
                  )}
                </span>
              </span>
              {item.value && (
                <span style={{ fontSize: "0.9rem" }}>{ formatPhoneNumber(item.label, item.value)}</span>
              )}
              {item.toggle && (
                <label className={styles.switch}>
                  <input type="checkbox" className={styles.input} onChange={handleChange} />
                  <span className={`${styles.slider} ${styles.round}`}></span>
                </label>
              )}
              {item.dropDown && (
                <div style={{ position: "relative" }}>
                  <Select
                    value={
                      item.options &&
                      item.options.find(
                        (itm) => itm.value === item?.dropDownValue
                      )
                    }
                    className={styles.profit_input1}
                    id={styles.selet}
                    options={item?.options}
                    onChange={handleChange}
                  />
                  <IoMdArrowDropdown
                    size={"1.1rem"}
                    style={{
                      position: "absolute",
                      top: "0.7rem",
                      right: "1rem",
                    }}
                  />
                </div>
              )}
            </div>
          ))}
      </div>
    </>
  );
};

export default AdminCommonComponent;





